import base64url from "base64url";
import { Buffer } from 'buffer';
import { JSONDecryptor, EncryptedData } from '../utils/encryptorUtil';
import config from "@config/config";

window.Buffer = Buffer;


export function encode(data: any): string {
    const jsonData = (JSON.stringify(data));
    return base64url.encode(jsonData);
}

export function decode(encodedData: any): any {
    const decodedString = base64url.decode(encodedData);
    return JSON.parse(decodedString);
}

function generateRandomKey() {
    const array = new Uint8Array(1); // Create a typed array for one random byte
    window.crypto.getRandomValues(array); // Fill it with secure random values
    return (array[0] % 9) + 1; // Get a number between 1 and 9 (inclusive)
}

export function encodeWithKeyAndShift(message: any): any {
    if (config.isPayloadEncryptionRequired) {
        const randomKey = generateRandomKey();

        //Shift each character in the message by the random key
        let shiftedMessage = '';
        for (let i = 0; i < message.length; i++) {
            shiftedMessage += String.fromCharCode(message.charCodeAt(i) + randomKey);
        }

        //Concatenate the random key to the end of the shifted message
        const combinedMessage = shiftedMessage + randomKey;

        //Base64 encode the result
        const base64Encoded = Buffer.from(combinedMessage).toString('base64');
        // Return the Base64 encoded message
        return base64Encoded;
    } else {
        return JSON.parse(message);
    }
    
}

export function decodeWithKeyAndShift(encodedMessage: any): any {
    try {
        if (!config.isPayloadEncryptionRequired) {
            return typeof encodedMessage === 'string'
                ? encodedMessage
                : JSON.stringify(encodedMessage);
        }

        // Global exception handler may return plain object
        if (
            encodedMessage === null ||
            encodedMessage === undefined ||
            typeof encodedMessage !== 'string'
        ) {
            return JSON.stringify(encodedMessage);
        }

        const combinedMessage = Buffer.from(
            encodedMessage,
            'base64'
        ).toString();

        const randomKey = parseInt(combinedMessage.slice(-1), 10);

        // Not a valid encrypted payload
        if (isNaN(randomKey)) {
            return encodedMessage;
        }

        const shiftedMessage = combinedMessage.slice(0, -1);

        let originalMessage = '';

        for (let i = 0; i < shiftedMessage.length; i++) {
            originalMessage += String.fromCharCode(
                shiftedMessage.charCodeAt(i) - randomKey
            );
        }

        return originalMessage;
    } catch {
        return typeof encodedMessage === 'string'
            ? encodedMessage
            : JSON.stringify(encodedMessage);
    }
}

export async function encryptData(data: any):Promise<EncryptedData>{
    const decryptor = new JSONDecryptor(process.env.SECRET_KEY||'');
    return await decryptor.encrypt(data);
}


export async function decryptData(data: EncryptedData){
    const decryptor = new JSONDecryptor(process.env.SECRET_KEY||'');
    return await decryptor.decrypt(data);
}

export async function uint8ToBase64(uint8Array: any) {
    let binary = "";
    const chunkSize = 0x8000; // process in 32KB chunks
    for (let i = 0; i < uint8Array.length; i += chunkSize) {
    const chunk = uint8Array.subarray(i, i + chunkSize);
    binary += String.fromCharCode.apply(null, chunk);
    }
    return btoa(binary);
};
